import { Decoration, Lockup } from '@superhi/design'
import React from 'react'

import { Wrapper } from './styles'

type Props = {
  hAlign?: 'center' | 'left'
  noPadding?: boolean
  children?: string
  subtitle?: string
}

const Loading = ({
  hAlign = 'center',
  noPadding = false,
  children = 'Loading...',
  subtitle,
}: Props) => (
  <Wrapper $noPadding={noPadding} $hAlign={hAlign}>
    <Decoration name="star" />
    <Lockup level="5" titleColor="GREY_90" title={children} subtitle={subtitle} />
  </Wrapper>
)

export default Loading
